/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseRewardImageUpload } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EmployerRewardsImageServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param employerId 
     * @param file 
     */
    employerRewardsImageControllerUpload0(employerId: string, file: Blob, extraHttpRequestParams?: any): Observable<ApiResponseRewardImageUpload>;

    /**
     * 
     * 
     * @param employerId 
     * @param file 
     */
    employerRewardsImageControllerUpload1(employerId: string, file: Blob, extraHttpRequestParams?: any): Observable<ApiResponseRewardImageUpload>;

}
